export const DESIGNATION_PLACEHOLDER = 'Product Designation'
export const SERVER_DESIGNATION_PLACEHOLDER = 'Insert drawing designation'
export const DESIGNATION_MAX_LENGTH = 50